import { createNativeStackNavigator } from '@react-navigation/native-stack'
import { Platform, View, Text } from 'react-native'
import { SafeAreaProvider } from 'react-native-safe-area-context'
import { fetchAuthSession, signOut } from 'aws-amplify/auth'
import NetInfo from '@react-native-community/netinfo'
import React, { useEffect, useState } from 'react'

import MyTabs from '../TabsNavigation'
import AppBar from '../../appBar/AppBar'
import WebLayout from '../../web/WebLayout'
import CourseHome, { Module } from '../../learning/CourseHome'
import Survey from '../../customUtils/SurveyBlock/survey'
// @ts-ignore - web-specific import
import SurveyModal from '../../customUtils/SurveyBlock/SurveyModal.web'
import { Notifications as NotificationsScreen } from '../../notifications/Notifications'
import { ProfileScreen } from '../../profile/ProfileScreen'
import EditProfileScreen from '../../profile/EditProfileScreen'
import { PortfolioProducts } from '../../portfolio/PortfolioProducts'
import { WebViewScreen } from '../../customUtils/Components/WebViewScreen'
import { PortfolioSubcategory } from '../../portfolio/PortfolioSubcategory'
import PortfolioProductDetail from '../../portfolio/PortfolioProductDetail'
import { ProductsModel } from '../../portfolio/models/PortfolioProductsModel'
import { CatalogueCategoriesModel } from '../../portfolio/models/PortfolioModel'
import { Schedule } from '../../stores/Schedule'
import { StoreDetail } from '../../stores/StoreDetail'
import LearningHome from '../../learning/learningHome'
import LearningHomeWeb from '../../learning/LearningHomeWeb'
import BenefitsHome from '../../benefits/benefitsHome'
import Portfolio from '../../portfolio/Portfolio'
import PostsList from '../../posts/PostsList'
import { useFetchBenefits } from '../../benefits/hooks/useFetchBenefits'
import { RedeemVoucherScreen } from '../../vouchers/RedeemVoucherScreen'
import { getGlobalVersion, openDB, updateGlobalVersion } from '../../../db/indexDB'
import { apiUrl } from '../../../config/config'
import { addCategory } from '../../../db/portfolio'
import { ExecutionView } from '../../stores/ExecutionView'
import { PerfectStoreVIew } from '../../stores/PerfectStoreVIew'
import { DataSheetModel, FormsModel, PerfectStoreModel, StepsModel } from '../../stores/models/StoreDetailModel'
import { TrackingServices } from '../../../../database/tracking.database'
import { WEBSOCKET_TYPES } from '../../../utils/Constants'
import initializeWebSocketInstance from '../../../utils/webSocketUtils'
import { PostsServices } from '../../../../database/posts.database'
import { useWebSocket } from '../../appBar/context/WebSocketContext'
import { getData } from '../../appBar/context/HeaderContext'
import { ActivitysModel, CampaignStepsModel, FormsAdvances } from '../../stores/models/ScheduleModel'
import { useFetchCourses } from '../../learning/hooks/useFetchCourses'
import { MapScreen } from '../../stores/MapScreen'
import { AddStores } from '../../stores/AddStores'
import { FormAnswers } from '../../stores/FormAnswers'
import { CreateSchedule } from '../../stores/CreateSchedule'
import { TriviaScreen } from '../../trivia/TriviaScreen'
import TriviaGame from '../../trivia/TriviaGame'
import { CreateScheduleModerator } from '../../stores/CreateScheduleModerator'
import { ModeratorRelevateDistributors } from '../../stores/ModeratorRelevateDistributors'
import { ModeratorRelevateWeeks } from '../../stores/ModeratorRelevateWeeks'
import { MyAdvance } from '../../myAdvance/MyAdvance'
import { AdvanceTeamRegion } from '../../myAdvance/models/MyAdvanceModel'
import { MyTeamAdvanceScreen } from '../../myAdvance/MyTeamAdvance'
import { MyTeamScreen } from '../../myAdvance/MyTeamScreen'
import { CreateScheduleHome } from '../../stores/CreateScheduleHome'
import { getConection } from '../../appBar/context/HeaderContext'
import { eventEmitter } from '../../../utils/functions.utils'
import { VouchersHistoryScreen } from '../../vouchers/VouchersScreen'
import CustomAlert from '../../customUtils/Components/CustomAlert'
import { getAlert } from '../../appBar/context/AlertsContext'
import TableViewerScreen from '../../appBar/utils/Database'
import { SecondarySplash } from '../../customUtils/SecondarySplash'
import { StorageAdapter } from '../../../utils/AsyncStorage'
import { useSecondarySplashStore } from '../../../redux/zustand/secondarySplashStore'
import { useAlertsGeneralControllersStore, useAlertTextPS } from '../../../redux/zustand/alertsGeneralControllersStore'
import { Gamification } from '../../gamification/Gamification'
import { GamificationRanking } from '../../gamification/GamificationRanking'
import { GamificationRoulette } from '../../gamification/GamificationRoulette'
import GamificationGame from '../../gamification/GamificationGame'
import { CreateStoreScreen } from '../../stores/CreateStoreScreen'
import theme from '../../../../theme'
import { FormsAnswersScreen } from '../../forms/FormsAnswersScreen'
import { RedeemVoucherModel } from '../../vouchers/models/RedeemVoucherModel'
import { useAndroidNavBarHeight } from '@/components/customUtils/hooks/useAndroidNavBarHeight'
import { NavigationContainer } from '@react-navigation/native'

export type DotsNavigation = {
    Main: undefined
    PostsList: undefined
    LearningHome: undefined
    Course: undefined
    Module: undefined
    Survey: undefined
    BenefitsHome: undefined
    Notifications: undefined
    Profile: undefined
    EditProfile: undefined
    WebView: undefined
    Portfolio: undefined
    SubCategory: { id: String; categories: CatalogueCategoriesModel[]; isBrand: boolean }
    PortfolioProducts: { categoryId: string; products: ProductsModel[]; item: CatalogueCategoriesModel }
    PortfolioProductDetail: { data: ProductsModel }
    Schedule: { navigate_store?: string }
    StoreDetail: {
        storeID: string
        forms?: string[]
        scheduleID: string
        steps: CampaignStepsModel[]
        forms_relevant: ActivitysModel[]
        forms_advances: FormsAdvances[]
        distance?: number
        store_status?: number
        navigate_form?: string
        incidence_answer?: string | null
    }
    RedeemVoucher: { voucher: RedeemVoucherModel }
    // ExecutionView: { forms: FormsModel[]; selectedIndex: number }
    ExecutionView: {
        forms: FormsModel[]
        selectedIndex: number
        schedule_id?: string
        store_id?: string
        storeInfo?: DataSheetModel
        checkin_id?: string
        status_store?: number
        statusCheckin?: number
    }
    PerfectStoreView: { perfectStore: PerfectStoreModel[]; selectedIndex: number; storeInfo?: DataSheetModel }
    MapScreen: { selectedScheduleID: string; campaign_schedule_free: boolean; campaignSteps: CampaignStepsModel[] }
    AddStores: { schedule_id?: string; distributor_id?: string }
    FormAnswers: undefined
    CreateScheduleHome: undefined
    CreateSchedule: { week_id: string; period_id: string }
    CreateScheduleModerator: undefined
    ModeratorRelevateDistributors: { id_period: string }
    ModeratorRelevateWeeks: { id_period: string; id_week: string }
    MyAdvance: undefined
    MyTeamAdvanceScreen: { regions: AdvanceTeamRegion[]; updateDate: string }
    MyTeamScreen: { id: string }
    VouchersHistoryScreen: undefined
    DatabaseScreen: undefined
    TriviaGame: undefined
    Gamification: undefined
    GamificationRanking: undefined
    GamificationRoulette: { levelID: String }
    GamificationGame: { level_id: string; game: any; pointsIfApproved: number }
    GamificationExit: undefined
    Chat: undefined
    ChatScreen: undefined
    ChatGroupScreen: undefined
    CreateStoreScreen: { schedule_id: string }
    FormsAnswersScreen: undefined
    ReelsViewer: { initialPostId: string | number }
}

const Stack = createNativeStackNavigator<DotsNavigation>()

// Aca se agrega la navegación lineal
function NavigationStack() {
    // WORKAROUND CRÍTICO: NativeStackNavigator causa crashes en web con indexed property setter
    // Bypass completo: renderizamos directamente el componente según currentFooterRoute
    // PERO: necesitamos montar MyTabs invisiblemente para ejecutar la inicialización
    if ((Platform as any).OS === 'web') {
        const { footerRoute, navigationParams } = getData()
        console.log('[NavigationStack][web] Bypassing NativeStack, rendering', footerRoute, '+ hidden MyTabs for init', 'params:', navigationParams)

        // Para Survey, renderizar Course debajo y modal encima
        const isSurveyRoute = footerRoute === 'Survey'

        // Renderizar componente según la ruta actual
        const renderCurrentScreen = () => {
            // Si es Survey, mostrar Course como pantalla base
            if (isSurveyRoute) {
                return <CourseHome />
            }

            switch (footerRoute) {
                case 'LearningHome':
                    return <LearningHomeWeb />
                case 'Course':
                    return <CourseHome />
                case 'Module':
                    // Module component expects route prop with params
                    return <Module route={{ params: navigationParams }} />
                case 'Portfolio':
                    return <Portfolio />
                case 'SubCategory':
                    // Portfolio subcategory navigation
                    // @ts-ignore - Passing simplified route object for web compatibility
                    return <PortfolioSubcategory route={{ params: navigationParams }} />
                case 'PortfolioProducts':
                    // Portfolio products list
                    // @ts-ignore - Passing simplified route object for web compatibility
                    return <PortfolioProducts route={{ params: navigationParams }} />
                case 'PortfolioProductDetail':
                    // Portfolio product detail
                    // @ts-ignore - Passing simplified route object for web compatibility
                    return <PortfolioProductDetail route={{ params: navigationParams }} />
                case 'Trivia':
                    // Trivia home screen with list and ranking
                    return <TriviaScreen />
                case 'TriviaGame':
                    // Trivia game screen (playing trivia)
                    // @ts-ignore - Passing simplified route object for web compatibility
                    return <TriviaGame route={{ params: navigationParams }} />
                case 'PostsList':
                default:
                    return <PostsList useCssColumnsMasonry />
            }
        }

        return (
            <View style={{ flex: 1 }}>
                <WebLayout>{renderCurrentScreen()}</WebLayout>

                {/* Survey como modal cuando la ruta es Survey */}
                {isSurveyRoute && (
                    <SafeAreaProvider>
                        <SurveyModal route={{ params: navigationParams }} />
                    </SafeAreaProvider>
                )}

                {/* Montar MyTabs escondido solo para ejecutar su useEffect de inicialización */}
                <View style={{ display: 'none', position: 'absolute', opacity: 0, pointerEvents: 'none' }}>
                    <MyTabs />
                </View>
            </View>
        )
    }

    // ErrorBoundary local para plataformas nativas
    const WebErrorBoundary: React.FC<{ children: any }> = ({ children }) => {
        const [err, setErr] = React.useState<any>(null)
        const ref = React.useRef({ hasMounted: false })
        if (err) {
            return (
                <View style={{ flex: 1, padding: 32, gap: 16 }}>
                    <Text style={{ fontSize: 18, fontWeight: '600' }}>Error de navegación</Text>
                    <Text style={{ fontFamily: 'monospace', fontSize: 12 }}>{String(err?.message || err)}</Text>
                    <Text
                        onPress={() => {
                            setErr(null)
                        }}
                        style={{ color: 'blue' }}
                    >
                        Reintentar montar navegación
                    </Text>
                </View>
            )
        }
        try {
            return children
        } catch (e) {
            setErr(e)
            return null
        }
    }
    //useFetchBenefits()
    const splashSecondary = useSecondarySplashStore((state) => state.splashSecondary)
    const { fetch_data } = useFetchCourses()
    const { isConnected, hasInternet } = getConection()
    const { visible, alertData, closeAlert } = getAlert()
    const [showSecondarySplash, setShowSecondarySplash] = useState(true)
    const [secondarySplashUri, setSecondarySplashUri] = useState('') //useState('https://resources-one.s3.us-east-2.amazonaws.com/salesbook/splash/arcor.png')
    const { setCurrentFooterRoute, footerRoute } = getData()
    const showAlertSnackbar = useAlertsGeneralControllersStore((store) => store.showAlertSnackbar)
    const setShowAlertSnackbar = useAlertsGeneralControllersStore((store) => store.setShowAlertSnackbar)

    const dataRender = useAlertTextPS((store) => store.dataRender)
    useEffect(() => {
        try {
            //get_info_users()
            eventEmitter.emit('starGeneralLoader')
            // fetch_data()
            // fetch_portfolio(isConnected, hasInternet)
            // sendTrackings()
            eventEmitter.emit('endGeneralLoader')
        } catch (error) {
            console.error('🚀 ~ useEffect ~ error:', error)
        }
    }, [])

    if (splashSecondary && showSecondarySplash) {
        return <SecondarySplash url={splashSecondary} hideSecondarySplash={() => setShowSecondarySplash(false)} />
    }
    const navBarHeight = useAndroidNavBarHeight()

    const stackContent = (
        <View style={{ backgroundColor: 'white', flex: 1 }}>
            <Stack.Navigator
                id={undefined}
                screenOptions={{
                    headerShown: (Platform as any).OS !== 'web',
                    header: (Platform as any).OS !== 'web' ? () => <AppBar /> : undefined,
                    contentStyle: { marginBottom: Platform.OS === 'android' ? navBarHeight : 0, backgroundColor: 'white' },
                }}
            >
                <Stack.Screen
                    name='Main'
                    component={MyTabs}
                    // options={{
                    //     navigationBarHidden: false,
                    //     navigationBarColor: footerRoute === 'Gamification' ? theme.colors.colorPrimary : 'white',
                    // }}
                    options={{ contentStyle: { marginBottom: 0 } }}
                />
                <Stack.Screen name='PostsList' component={PostsList} />
                <Stack.Screen name='LearningHome' component={LearningHome} />
                <Stack.Screen
                    name='Course'
                    component={CourseHome}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('Course')
                        },
                    }}
                />
                <Stack.Screen
                    name='Module'
                    component={Module}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('Module')
                        },
                    }}
                />
                <Stack.Screen
                    name='Survey'
                    component={Survey}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('Survey')
                        },
                    }}
                />
                <Stack.Screen
                    name='BenefitsHome'
                    component={BenefitsHome}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('BenefitsHome')
                        },
                    }}
                />
                <Stack.Screen
                    name='ReelsViewer'
                    component={require('../../posts/ReelsViewer').default}
                    options={{ headerShown: false, animation: 'slide_from_bottom' }}
                />
                <Stack.Screen
                    name='Notifications'
                    component={NotificationsScreen}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('Notifications')
                        },
                    }}
                />
                <Stack.Screen
                    name='Profile'
                    component={ProfileScreen}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('Profile')
                        },
                    }}
                />
                <Stack.Screen
                    name='EditProfile'
                    component={EditProfileScreen}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('EditProfile')
                        },
                    }}
                />
                <Stack.Screen
                    name='WebView'
                    component={WebViewScreen}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('WebView')
                        },
                    }}
                />
                <Stack.Screen
                    name='Portfolio'
                    component={Portfolio}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('Portfolio')
                        },
                    }}
                />
                <Stack.Screen
                    name='SubCategory'
                    component={PortfolioSubcategory}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('SubCategory')
                        },
                    }}
                />
                <Stack.Screen
                    name='PortfolioProducts'
                    component={PortfolioProducts}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('PortfolioProducts')
                        },
                    }}
                />
                <Stack.Screen
                    name='PortfolioProductDetail'
                    component={PortfolioProductDetail}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('PortfolioProductDetail')
                        },
                    }}
                />
                <Stack.Screen
                    name='Schedule'
                    component={Schedule}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('Schedule')
                        },
                    }}
                />
                <Stack.Screen
                    name='StoreDetail'
                    component={StoreDetail}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('StoreDetail')
                        },
                    }}
                />
                <Stack.Screen
                    name='RedeemVoucher'
                    component={RedeemVoucherScreen}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('RedeemVoucher')
                        },
                    }}
                />
                <Stack.Screen
                    name='ExecutionView'
                    component={ExecutionView}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('ExecutionView')
                        },
                    }}
                />
                <Stack.Screen
                    name='FormAnswers'
                    component={FormAnswers}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('FormAnswers')
                        },
                    }}
                />
                <Stack.Screen
                    name='PerfectStoreView'
                    component={PerfectStoreVIew}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('PerfectStoreView')
                        },
                    }}
                />
                <Stack.Screen
                    name='MapScreen'
                    component={MapScreen}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('MapScreen')
                        },
                    }}
                />
                <Stack.Screen
                    name='AddStores'
                    component={AddStores}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('AddStores')
                        },
                    }}
                />
                <Stack.Screen
                    name='CreateSchedule'
                    component={CreateSchedule}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('CreateSchedule')
                        },
                    }}
                />
                <Stack.Screen
                    name='CreateScheduleModerator'
                    component={CreateScheduleModerator}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('CreateScheduleModerator')
                        },
                    }}
                />
                <Stack.Screen
                    name='ModeratorRelevateDistributors'
                    component={ModeratorRelevateDistributors}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('ModeratorRelevateDistributors')
                        },
                    }}
                />
                <Stack.Screen
                    name='ModeratorRelevateWeeks'
                    component={ModeratorRelevateWeeks}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('ModeratorRelevateWeeks')
                        },
                    }}
                />
                <Stack.Screen
                    name='MyAdvance'
                    component={MyAdvance}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('MyAdvance')
                        },
                    }}
                />
                <Stack.Screen
                    name='MyTeamAdvanceScreen'
                    component={MyTeamAdvanceScreen}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('MyTeamAdvanceScreen')
                        },
                    }}
                />
                <Stack.Screen
                    name='MyTeamScreen'
                    component={MyTeamScreen}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('MyTeamScreen')
                        },
                    }}
                />
                <Stack.Screen
                    name='CreateScheduleHome'
                    component={CreateScheduleHome}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('CreateScheduleHome')
                        },
                    }}
                />
                <Stack.Screen
                    name='VouchersHistoryScreen'
                    component={VouchersHistoryScreen}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('VouchersHistoryScreen')
                        },
                    }}
                />
                <Stack.Screen
                    name='DatabaseScreen'
                    component={TableViewerScreen}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('DatabaseScreen')
                        },
                    }}
                />
                <Stack.Screen
                    name='TriviaGame'
                    component={TriviaGame}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('TriviaGame')
                        },
                    }}
                />
                <Stack.Screen
                    name='Gamification'
                    component={Gamification}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('Gamification')
                        },
                    }}
                    options={
                        {
                            // headerShown: false, // To hide header native
                            // navigationBarColor: theme.colors.colorPrimary, // Android Navigation Color
                            // navigationBarHidden: false,
                        }
                    }
                />
                <Stack.Screen
                    name='GamificationRanking'
                    component={GamificationRanking}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('Gamification')
                        },
                    }}
                    options={
                        {
                            // navigationBarHidden: false,
                            // navigationBarColor: theme.colors.colorPrimary,
                        }
                    }
                />
                <Stack.Screen
                    name='GamificationRoulette'
                    component={GamificationRoulette}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('Gamification')
                        },
                    }}
                    options={
                        {
                            // navigationBarHidden: false,
                            // navigationBarColor: theme.colors.colorPrimary,
                        }
                    }
                />
                <Stack.Screen
                    name='GamificationGame'
                    component={GamificationGame}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('Gamification')
                        },
                    }}
                    options={
                        {
                            // navigationBarHidden: true,
                        }
                    }
                />

                {/* <Stack.Screen name='Chat' component={Chat} />
                <Stack.Screen name='ChatScreen' component={ChatScreen} />
                <Stack.Screen name='ChatGroupScreen' component={ChatGroupScreen} /> */}
                <Stack.Screen
                    name='CreateStoreScreen'
                    component={CreateStoreScreen}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('CreateStoreScreen')
                        },
                    }}
                />
                <Stack.Screen
                    name='FormsAnswersScreen'
                    component={FormsAnswersScreen}
                    listeners={{
                        focus: () => {
                            setCurrentFooterRoute('FormsAnswersScreen')
                        },
                    }}
                />
            </Stack.Navigator>
            {visible && (
                <CustomAlert
                    visible={true}
                    backgroundColor={alertData.backgroundColor}
                    textColor={alertData.textColor}
                    nameIcon={alertData.image}
                    iconLibrary={alertData.iconLibrary}
                    iconSize={alertData.iconSize}
                    message={alertData.text}
                    onClose={() => closeAlert()} // Cerrar el modal cuando se presiona el icono 'X'
                />
            )}

            {showAlertSnackbar && (
                <CustomAlert
                    visible={true}
                    backgroundColor={dataRender.color}
                    textColor={'white'}
                    nameIcon={null}
                    iconLibrary={'Feather'}
                    iconSize={20}
                    message={dataRender.description}
                    onClose={() => setShowAlertSnackbar(false)}
                    secondMessage={dataRender.secondMessage}
                />
            )}
        </View>
    )

    if ((Platform as any).OS === 'web') {
        return (
            <View style={{ flex: 1 }}>
                <WebErrorBoundary>
                    <WebLayout>{stackContent}</WebLayout>
                </WebErrorBoundary>
            </View>
        )
    }

    return stackContent
}
export default NavigationStack

const fetch_portfolio = async (hasInternet, isConnected) => {
    try {
        let data
        const database = await openDB()
        const currentGlobalVersion = await getGlobalVersion(database, 'catalogue')
        let fetch_error = false

        if (isConnected && hasInternet) {
            const session = await fetchAuthSession()
            const authToken = session.tokens?.accessToken?.toString() || ''
            if (session) {
                const response = await fetch(`${apiUrl}/ecommerce_brands`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: authToken,
                        version: currentGlobalVersion,
                    },
                })
                // console.log('Portfolio: verison que mando ,', currentGlobalVersion)
                if (!response.ok) {
                    console.error('Fallo al obtener el catalogo')
                    console.log('Intento consumir catalogo de mi local')

                    fetch_error = true
                }

                if (!fetch_error) {
                    data = await response.json()
                    //   console.log('🚀 ~ file: Portfolio.tsx:90 ~ fetchData ~ data:', data)
                    // console.log('🚀 ~ data.data_version:', data.single.data_version)
                    // // console.log('🚀 ~ data.data_version:', data)

                    if (data?.status === 1) {
                        data.single.categories.forEach(async (category) => {
                            try {
                                await addCategory(database, category)
                            } catch (error) {
                                //  console.log("🚀 ~ data.single.data.forEach ~ error:", error)
                            }
                        })

                        let version_update = data.single.data_version
                        await updateGlobalVersion(database, 'catalogue', version_update)
                    }
                }
            }
        }
    } catch (error) {
        console.error('fetch_portfolio => ', error)
    }
}
